import { useCallback, useSyncExternalStore } from 'react';
import type { MessengerThread } from '@/api/client';
import {
  getMessengerThreadById,
  subscribeMessengerThreadById,
} from '@/components/Messenger/cache/messengerThreadsStore';

export function useMessengerThreadById(threadId: string): MessengerThread | undefined {
  return useSyncExternalStore(
    useCallback((onChange) => subscribeMessengerThreadById(threadId, onChange), [threadId]),
    () => getMessengerThreadById(threadId),
    () => undefined
  );
}
